import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import * as auth from "../actions/auth";
import * as rocketChatAction
  from "../modules/rocketChat/actions/rocketChatAction";
import * as notificationAction
  from "../modules/notification/actions/notificationsAction";
import {Layout} from "../components/Layout";
import NotificationPopup from "../components/NotificationPopup";
import InfoOverlay from "./InfoOverlay";

import * as userAction from "../../screens/user/actions/userAction";
import {NOTIFICATION_WARNING} from "../modules/notification/constants";
import {ROUTER_MEMBERS_INVITE, ROUTER_USER_LOGIN,} from "../constants/routers";
import {
  USER_OFFLINE,
  USER_ONLINE
} from "../../screens/user/constants/actionTypes";


export class AuthLayout extends React.Component {
  static propTypes = {
    ...Layout.propTypes,
    rocketChat: PropTypes.object
  };

  static defaultProps = {
    ...Layout.defaultProps,
    rocketChat: {
      notifications: []
    },
    navbar: true
  };

  componentDidMount() {
    if (!auth.is()) {
      this.props.history.replace(ROUTER_USER_LOGIN);
      return;
    }
    this.props.dispatch(userAction.getProfile())
      .then(
        (user) => {
          if (user) {
            this.props.dispatch(rocketChatAction.login(user.email));
            window.addEventListener('online', () => {
              this.props.dispatch({type: USER_ONLINE});
              this.props.dispatch(rocketChatAction.reconnect());
            });
            window.addEventListener('offline', () => {
              this.props.dispatch({type: USER_OFFLINE});
            });
          }
        },
        (err) => {
          if (err.status === 401) {
            this.props.dispatch(
              notificationAction.addNotification(
                __("Your session has expired, please register again."),
                NOTIFICATION_WARNING
              )
            );
            this.props.dispatch(userAction.logout())
              .then(() => {
                this.props.history.push(ROUTER_USER_LOGIN);
              });
          }
        }
      )
      .then(() => {
          window.scrollTo(0, 0);
        }
      );
  }

  /**
   * Gets extended parent props
   * @param {object} parentProps parent props
   * @returns {object} gets props
   */
  getExtendedProps(parentProps) {
    return Object
      .keys(parentProps)
      .reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue]: this.props[currentValue]
        }),
        {}
      );
  }

  render() {
    const notifications = this.props.rocketChat.notifications
      .map((notification, index) => {
        if (!notification.isAtChatStream(this.props.message.user)) {
          return (
            <NotificationPopup
              notification={notification}
              key={index}
            />
          )
        }
      });

    return (
      <Layout {...this.getExtendedProps(Layout.propTypes)}>
        {notifications}
        {this.props.children}
        {this.props.user.visible &&
        <InfoOverlay overlayText={__("Invite more members!")}
                     overlayLinkRef={ROUTER_MEMBERS_INVITE}
                     overlayLinkText={__("Invite person to the family portal")}
                     overlayButtonText={__("Roger that")}
                     overlayBackground="#fff"/>}
      </Layout>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    rocketChat: state.rocketChat,
    user: state.user,
    message: state.message
  };
};

export default withRouter(connect(mapStateToProps)(AuthLayout));
